import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/watches";
import { Reveal } from "./Reveal";

const FaqItem = ({ item, index, open, onToggle }) => {
  return (
    <Reveal
      delay={index * 60}
      className="border-t border-white/10 last:border-b last:border-white/10"
    >
      <button
        type="button"
        onClick={onToggle}
        data-testid={`faq-toggle-${index}`}
        className="w-full text-left py-7 sm:py-8 flex items-start gap-6 group"
        aria-expanded={open}
      >
        <span className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-[var(--brand-gold)] mt-2 shrink-0 w-8">
          0{index + 1}
        </span>
        <span className="flex-1 font-serif-rw text-2xl sm:text-3xl font-light text-slate-50 leading-tight group-hover:text-[var(--brand-gold)] transition-colors">
          {item.q}
        </span>
        <span className="mt-2 shrink-0 text-[var(--brand-gold)]">
          {open ? <Minus size={20} strokeWidth={1.5} /> : <Plus size={20} strokeWidth={1.5} />}
        </span>
      </button>
      <div
        className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out ${
          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="pl-14 pr-4 pb-8 text-base text-slate-400 leading-relaxed font-light max-w-3xl">
            {item.a}
          </p>
        </div>
      </div>
    </Reveal>
  );
};

export const Story = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      id="faqs"
      data-testid="faq-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12 bg-[var(--brand-surface)]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-[var(--brand-gold)]" />
            Preguntas frecuentes
          </div>
          <h2 className="font-serif-rw text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-slate-50 lg:sticky lg:top-32">
            Todo claro <br />
            <em className="italic text-[var(--brand-gold)] font-light">
              desde el principio.
            </em>
          </h2>
          <p className="mt-8 text-base text-slate-400 leading-relaxed font-light max-w-md lg:sticky lg:top-64">
            Aquí van las dudas más comunes. Si te queda alguna, escríbenos por
            WhatsApp y te respondemos en menos de 2 horas.
          </p>
        </Reveal>

        <div className="lg:col-span-8">
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              index={i}
              open={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Story;
